/**
 * @generated SignedSource<<447038276454656d5e745b09d48483ad>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type jiraTab_navigationKitTabListOld$data = {
  readonly __typename: string;
  readonly " $fragmentSpreads": FragmentRefs<"simpleNavigationTab_businessTabs">;
  readonly " $fragmentType": "jiraTab_navigationKitTabListOld";
};
export type jiraTab_navigationKitTabListOld$key = {
  readonly " $data"?: jiraTab_navigationKitTabListOld$data;
  readonly " $fragmentSpreads": FragmentRefs<"jiraTab_navigationKitTabListOld">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "name": "jiraTab_navigationKitTabListOld",
  "selections": [
    {
      "kind": "ScalarField",
      "name": "__typename"
    },
    {
      "kind": "FragmentSpread",
      "name": "simpleNavigationTab_businessTabs"
    }
  ],
  "type": "JiraNavigationItem",
  "abstractKey": "__isJiraNavigationItem"
};

(node as any).hash = "ba1f2747c0ac78b804fc3aabe3484099";

export default node;
